<form lin-layout-form [formGroup]="form" (ngSubmit)="submitForm()">
  <lin-layout-form-sections-wrapper layout="triple">
    <lin-layout-form-section>
      <h2>{{ 'Document Info' | translate }}</h2>

      @if (documentSubject === 'driver') {
      <lin-form-label required>{{ 'FIELDS.DRIVER_NAME' | translate }}:</lin-form-label>
      <lin-autocomplete-field
        linAutocompleteFieldValidator
        formControlName="driver"
        [displayWith]="displayDriverName"
        [autocompleteRequest]="getDriverList"
      >
      </lin-autocomplete-field>
      @if (form.get('driver').dirty && form.get('driver').hasError('invalid')) {
      <mat-error class="lin-autocomplete-error">{{ 'ERRORS.DRIVER_REQUIRED' | translate }}</mat-error>
      } } @if (documentSubject === 'vehicle') {
      <lin-form-label required>{{ 'CLIENT.VEHICLES.VEHICLE_REGNO' | translate }}:</lin-form-label>
      <lin-autocomplete-field
        linAutocompleteFieldValidator
        formControlName="vehicle"
        [displayWith]="displayVehicleRegNo"
        [autocompleteRequest]="getVehicleList"
      >
      </lin-autocomplete-field>
      @if (form.get('vehicle').dirty && form.get('vehicle').hasError('invalid')) {
      <mat-error class="lin-autocomplete-error">{{ 'ERRORS.VEHICLE_REQUIRED' | translate }}</mat-error>
      } } @if (documentSubject === 'asset') {
      <lin-form-label required>{{ 'FIELDS.assetId' | translate }}:</lin-form-label>
      <lin-autocomplete-field
        linAutocompleteFieldValidator
        formControlName="asset"
        [displayWith]="displayAssetName"
        [autocompleteRequest]="getAssetList"
      >
      </lin-autocomplete-field>
      @if (form.get('asset').dirty && form.get('asset').hasError('invalid')) {
      <mat-error class="lin-autocomplete-error">{{ 'ERRORS.ASSET_REQUIRED' | translate }}</mat-error>
      } }

      <lin-form-label required>{{ 'FIELDS.TITLE' | translate }}</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="title" autocomplete="off" />
        <mat-error><lin-form-field-error [control]="form.get('title')" controlName="title"></lin-form-field-error></mat-error>
      </mat-form-field>

      @if (document) {
      <lin-form-label>{{ 'CLIENT.VEHICLES.DOCUMENTS.ISSUE_DATE' | translate }}: {{ document?.issueDate | dayjsDate }}</lin-form-label>

      <lin-form-label>
        {{ 'FIELDS.expirationDate' | translate }}: {{ (document?.noExpiry ? ('CLIENT.VEHICLES.DOCUMENTS.NO_EXPIRY' | translate) :
        (document?.expDate | dayjsDate)) || '-' }}
      </lin-form-label>

      <lin-form-label class="document-status"
        >{{ 'CLIENT.VEHICLES.DOCUMENTS.DOCUMENT_STATUS' | translate }}: {{ DocumentStatusLabel[document?.status] | translate
        }}</lin-form-label
      >
      } @if (!document || document.expDate) {
      <lin-form-label>{{ 'CLIENT.VEHICLES.DOCUMENTS.NOTIFY_BEFORE' | translate }}</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="notifyBefore" type="number" step="1" min="0" autocomplete="off" />
        <mat-error><lin-form-field-error [control]="form.get('notifyBefore')" controlName="notifyBefore"></lin-form-field-error></mat-error>
      </mat-form-field>
      } @if (document) {
      <lin-form-submit-button [isDisabled]="!isEditMode" [isLoading]="isSubmitting">
        {{ 'CLIENT.VEHICLES.DOCUMENTS.SAVE_DOCUMENT_INFO' | translate }}
      </lin-form-submit-button>
      }
    </lin-layout-form-section>

    @if (isRecordAddMode && isEditMode) {
    <lin-document-record-form
      [document]="document"
      [documentSubject]="documentSubject"
      [documentForm]="form"
      [isEditMode]="isEditMode"
      [isArchived]="isArchived"
      [prepareDocumentInfoData]="prepareDocumentInfoData()"
      (recordAdded)="onRecordAdded($event)"
    >
    </lin-document-record-form>
    }
  </lin-layout-form-sections-wrapper>
</form>

@if (document?.records && isRecordMode) {
<lin-document-records-list
  [records]="document.records"
  [isEditMode]="isEditMode"
  (editRecord)="editRecord($event)"
></lin-document-records-list>
}
